<template>
    <ValidationProvider
        v-slot="{ classes, errors }"
        ref="provider"
        :rules="rules"
        :custom-messages="customMessages"
        :name="name"
        :class="containerClasses"
        tag="div"
        mode="eager"
    >
        <div class="digi-input w-full" :class="classes">
            <label class="form-label font-inter text-viva-money-black font-bold" :for="name" v-html="errors[0] || label"></label>
            <div class="form-input -m-2">
                <div class="form-input-inner p-2 w-full">
                    <div class="input-wrapper w-full relative">
                        <input
                            :name="name"
                            :type="type"
                            :value="value"
                            @change="handleChange"
                            @input="handleInput"
                            @focus="handleFocus"
                            @blur="handleBlur"
                            v-bind="attributes"
                            v-number-only="['number', 'tel'].includes(type)"
                            class="textbox bg-white h-12 w-full border-viva-money-black border-2 focus:border-viva-money-secondary-yellow outline-none p-4 text-base"
                            :class="$attrs['input-classes']"
                        />
                        <slot></slot>
                    </div>
                </div>
            </div>
            <div v-if="microtext" class="form-microtext mt-4">
                <small v-html="microtext"></small>
            </div>
            <div v-if="tooltip" class="w-full h-4 mt-1">
                <small v-if="shouldShowTooltip" class="text-viva-money-black text-base font-medium font-inter" v-html="tooltip"></small>
            </div>
        </div>
    </ValidationProvider>
</template>
 
<script>
export default {
    created() {
        if (this.value) {
            this.$nextTick(() => {
                if (this.value) {
                    this.$refs.provider.validate(this.value);
                } else {
                    this.$refs.provider.reset();
                }
            });
        }
    },
    data: function () {
        return {
            showTooltip: false,
        };
    },
    computed: {
        shouldShowTooltip() {
            return this.showTooltip;
        },
    },
    props: {
        rules: {
            default: () => {
                return {};
            }
        },
        customMessages: {
            default: () => {
                return {};
            }
        },
        attributes: {
            default: {}
        },
        value: {
            default: ""
        },
        name: {
            default: ""
        },
        label: {
            default: ""
        },
        options: {
            default: () => {
                return {};
            },
            type: Object
        },
        valid: {
            default: null
        },
        type: {
            default: "text"
        },
        microtext: {
            default: null
        },
        containerClasses: {
            default: () => {
                return [ 'mb-8' ];
            }
        },
        tooltip: {
            default: null
        }
    },
    methods: {
        handleChange(e) {
            this.$emit("change", e.target.value);
        },
        handleInput(e) {
            this.$emit("input", e.target.value);
        },
        handleFocus(e) {
            this.showTooltip = true;
        },
        handleBlur(e) {
            if (this.name === 'bank_details.account_number' && this.value.length === 7) {
                this.$emit("prefix_account_number", this.value);
            }
            if (this.value === null) {
                window.amplitude.inputBoxInteractionEvent(this.name, 'User has left the field blank');
            }
            if (this.value !== null) {
                setTimeout(() => {
                    window.amplitude.inputBoxInteractionEvent(this.name, this.$refs.provider.flags.valid === true ? 'valid' : 'invalid');
                }, 500)
            }
            this.showTooltip = false;
        },        
    },
};
</script>
<style lang="scss">
.digi-input.valid {
    .textbox {
        box-shadow: inset 0 0 0 1px #F0BA46;
        border-color: #F0BA46;
        border-width: 1px;
    }
}

.digi-input.invalid {
    .textbox {
        box-shadow: inset 0 0 0 1px #FF6B6C;
        border-color: #FF6B6C;
        border-width: 1px;
    }
}
</style>